var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.getIsDialogLoading,
      expression: "getIsDialogLoading"
    }],
    staticStyle: {
      "padding": "16px !important"
    },
    attrs: {
      "visible": _vm.dialogOpened,
      "width": "465px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "destroy-on-close": "",
      "show-close": false,
      "center": ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogOpened = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function ($event) {
              return _vm.closeDialog();
            }
          }
        }, [_vm._v(_vm._s(_vm.LABEL_CANCEL))]), _vm._v(" "), _c('div', [_c('div', [_c('el-button', {
          staticStyle: {
            "padding": "6.5px 12px"
          },
          attrs: {
            "type": "primary",
            "loading": _vm.saveBtnLoading
          },
          on: {
            "click": function ($event) {
              return _vm.submit();
            }
          }
        }, [_vm._v(_vm._s(_vm.LABEL_YES_PROCEED))])], 1)])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icons/warning-employement.svg")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "title text-sm mt-2 text-black",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "description text-sm mt-4"
  }, [_vm._v("\n        " + _vm._s(_vm.RESEND_DOCUSIGN_ENVELOPE_DESCRIPTION) + "\n      ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }